import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"label":_vm.$t('Rule'),"dense":"","outlined":"","hide-details":"auto","items":_vm.rules,"clearable":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-capitalize"},[_vm._v(" "+_vm._s(_vm.$t(_vm.getOperatorLabel(item)))+" ")])]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-capitalize"},[_vm._v(" "+_vm._s(_vm.$t(_vm.getOperatorLabel(item)))+" ")])]}}]),model:{value:(_vm.rule),callback:function ($$v) {_vm.rule=$$v},expression:"rule"}})}
var staticRenderFns = []

export { render, staticRenderFns }